<template>
  <div class="col-12">
    <transition mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "CdlSaude",
  data() {
    return {
      produto: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
        },
      ],
    };
  },
  methods: {},
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
  },
};
</script>
